export default {
    FILTER_TEXT_PLACEHOLDER: "Поиск"
};
